export { default } from '@klokhuis/modules/Commons/pages/Privacy/Privacy.page';
